export default __webpack_public_path__ + "static/media/GAT-COM.89b323f3.png";